export function resolveInvokeEventSelectedData(data: unknown): unknown {
  if (data == null) return undefined
  if (
    typeof data === 'object' &&
    typeof (data as { getField?: unknown }).getField === 'function' &&
    typeof (data as { hasField?: unknown }).hasField === 'function'
  ) {
    return undefined
  }
  const d = data as { selectedData?: unknown; selected?: unknown }
  return d.selectedData ?? d.selected ?? data
}
